// 获取Cookie
export function getCookie(name) {
 var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
 if (arr = document.cookie.match(reg))
  return (arr[2]);
 else
  return null;
}
 
//设置cookie,增加到vue实例方便全局调用
export function setCookie (c_name, value, expiredays) {
 var exdate = new Date();
 exdate.setDate(exdate.getDate() + expiredays);
 document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
};


 
//删除cookie
export function delCookie (name) {
 var exp = new Date();
 exp.setTime(exp.getTime() - 1);
 var cval = getCookie(name);
 if (cval != null)
  document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};


export function setStorage(name, data) {
    let dataType = typeof data;
    // json对象
    if(dataType === 'object'){
        window.localStorage.setItem(name, JSON.stringify(data));
    }
    // 基础类型
    else if(['number','string','boolean'].indexOf(dataType) >= 0){
        window.localStorage.setItem(name, data);
    }
    // 其他不支持的类型
    else{
        alert('该类型不能用于本地存储');
    }
}
// 取出本地存储内容
export function getStorage(name){
    let data = window.localStorage.getItem(name);
    if(data){
        return JSON.parse(data);
    }
    else{
        return '';
    }
}
// 删除本地存储
export function removeStorage(name){
    window.localStorage.removeItem(name);
}


// WEBPACK FOOTER //
// ./src/util/util.js